import { useAppTranslation } from '@hooks/useAppTranslation';
import { useMemo } from 'react';
import { buildReportsCsvColumns } from './useReportsCsvExport.columns';
import type {
  UseReportsCsvExportOptions,
  UseReportsCsvExportResult,
} from './useReportsCsvExport.types';
import { buildReportCsvContent } from './useReportsCsvExport.utils';

export const useReportsCsvExport = ({
  reports,
  filePrefix = 'reports',
}: UseReportsCsvExportOptions): UseReportsCsvExportResult => {
  const { t, language } = useAppTranslation();
  const canExport = reports.length > 0;
  const columns = useMemo(() => buildReportsCsvColumns(t, language), [language, t]);

  const exportCsv = (): void => {
    if (!canExport) {
      return;
    }

    const csvContent = buildReportCsvContent(reports, columns);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const dateStamp = new Date().toISOString().slice(0, 10);

    link.href = url;
    link.download = `${filePrefix}-${dateStamp}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return { exportCsv, canExport };
};
